import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpRequest from "../../services/httpRequest";
import AppUtil from "utilities/AppUtil";


const _urlPrefix = "/dashboard";

export const fetchDashboard = createAsyncThunk(
  "dashboard/fetchDashboard",
  async (params) => {
    const requestParams = { ...params };
    delete requestParams.months;
    const result = await httpRequest({
      url: `${_urlPrefix}`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(requestParams)
    });
    if (!result) {
      return;
    }
    if (result.data) {
      return { ...result.data, months: params.months };
    } else {
      return result.data;
    }
  }
);

export const fetchDashboardCompany = createAsyncThunk(
  "dashboard/fetchDashboardCompany",
  async (params) => {
    const requestParams = { ...params };
    delete requestParams.months;
    delete requestParams.weeks;
    const result = await httpRequest({
      url: `${_urlPrefix}/company`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(requestParams)
    });
    if (!result) {
      return;
    }
    if (result.data) {
      return { ...result.data, months: params.months, weeks: params.weeks };
    } else {
      return result.data;
    }
    
  }
);

const slice = createSlice({
  name: "dashboard",
  initialState: {

  },
  reducers: {

  },
  extraReducers: {

  }
});

export default slice.reducer;
